import { AccessorsMutatorsDecorator, isInstanceOf } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Country } from "./country.model";
import { Property } from './property.model';
import moment from 'moment';

/**
 * @class Account
 * @property {number} id
 * @property {string} name
 * @property {integer} status
 * @property {string} email
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} phone_code
 * @property {string} phone_number
 * @property {string} address
 * @property {date} created_at
 * @property {Country} country
 * @property {Property[]} properties
 */
export class Account extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [];
    }

    get owner() {
        const f_name = this.first_name ? this.first_name : '';
        const l_name = this.last_name ? this.last_name : '';

        return `${f_name} ${l_name}`;
    }

    get phone() {
        return  (this.phone_code || this.phone_number) ? `+${this.phone_code}${this.phone_number}` : '';
    }

    get registered() {
        return moment(this.created_at).format('DD/MM/YYYY');
    }

    /**
     * @param {Object|Country} value
     * @returns {Country}
     */
    setCountry(value) {

        if(value === null) {

            return {};
        }
        if (typeof value === 'undefined') {

            return value;
        }

        return value instanceof Country ? value : new Country(value);
    }

    setProperties(value) {

        if (!Array.isArray(value) || !isInstanceOf(Property, value[0])) {

            value = Property.factory(value);
        }

        return value;
    }

    static get validationModel() {

        return {
            country: {
                label: 'COUNTRY'
            }
        };
    }
}

AccessorsMutatorsDecorator('id',  ...Account.translatableAttributesWithLanguageAliases, 'name', 'status', 'email',
    'phone_code', 'phone_number', 'address', 'created_at', 'first_name', 'activate_sms_auth',
    'last_name', 'country', 'properties', 'country_id', 'is_password_set', 'password', 'password_confirmation')(Account);


// WEBPACK FOOTER //
// ./src/pms-api/models/account.model.js